import { render, staticRenderFns } from "./no_data.vue?vue&type=template&id=d079d006"
import script from "./no_data.vue?vue&type=script&lang=js"
export * from "./no_data.vue?vue&type=script&lang=js"
import style0 from "./no_data.vue?vue&type=style&index=0&id=d079d006&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports